import client from './client';
export const reportsAPI = {
    async shareScanByEmail(hash, email) {
        const response = await client.post(`/reports/share/${hash}`, { email });
        return response.data.data;
    },
};
